import script from "./SimplePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./SimplePagination.vue?vue&type=script&setup=true&lang=js"

import "./SimplePagination.vue?vue&type=style&index=0&id=9d600616&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d600616"]])

export default __exports__